module.exports = "<div class=\"kan-dog-container\">\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/dog/dog/component.html
// module id = ./src/modules/admin/components/dog/dog/component.html
// module chunks = main